import { SearchResponseDetails } from './search-response-details';
/**
 * The top-level response model when retrieving a response from the advanced search endpoint.
 *
 * @export
 * @class SearchResponse
 */
export class SearchResponse {
    constructor(json) {
        this.rawResponse = json;
        this.responseHeader = json.responseHeader;
        this.response = new SearchResponseDetails(json.response);
    }
}
//# sourceMappingURL=search-response.js.map